/**
 * Return mocked state object
 * @param {boolean} hasColoursInPathname - Indicates if colours are included in the pathname.
 * @returns {Object} The mocked state object.
 */
export default function initialStateForUpdateQuery(hasColoursInPathname) {
  return {
    app: {
      routing: {
        pathname: hasColoursInPathname
          ? 'collections/all-lingerie/colours/blue/'
          : 'collections/all-lingerie/',
      },
    },
  };
}
